import {_Events} from "./_Events";
import {_Reservations} from "./_Reservations";

export const _Admin = {
    Events:_Events,
    Reservations: _Reservations
}